import { combineReducers } from 'redux';
import emailExample from './emailExample';
import PastOrders from './PastOrders';
import App from './App';
import analytics from './analytics';

export default combineReducers({
    emailExample, PastOrders, App, analytics,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.ts